function checkShowSelected(el) {
  const targetParent = el.dataset.portalSlug ? $(el) : $(el).closest('[data-portal-slug]');
  const selectVal = targetParent.find('[name="publication_option[option]"]').val();
  const infojobsAccordion = targetParent.find('.infojobs-extra-info');

  if (selectVal) {
    infojobsAccordion.removeClass('is-hidden');
    targetParent.find('[data-option-key]').each((index, elem) => {
      $(elem).toggleClass('is-hidden', elem.dataset.optionKey !== selectVal);
    });
  } else {
    infojobsAccordion.addClass('is-hidden');
    targetParent.find('[data-option-key]').each((index, elem) => {
      $(elem).addClass('is-hidden');
    });
  }
}

function updateInfojobsInfo() {
  $('[data-portal-slug*=infojobs]').each((_, elem) => checkShowSelected(elem));
}

$(document).on('change', '[data-portal-slug*=infojobs] [name="publication_option[option]"]', (e) => checkShowSelected(e.target));

$(document).on('dom-update', () => {
  updateInfojobsInfo();
});
